import { Box, Slide } from "@mui/material";
import React, { forwardRef, useRef } from "react";
import FormCorreoElectronico from "./components/FormCorreoElectronico";

const CorreoElectronico = forwardRef(function CorreoElectronico(
  { nextStep, prevStep, showToast, setHeight, hidden, ...props },
  ref
) {
  const divElement = useRef(null);
  return (
    <div hidden={hidden}>
      <Slide direction="left" in={!hidden} timeout={200}>
        <Box
          ref={divElement}
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            display: "flex",
            justifyContent: "end",
            p: 1,
          }}
        >
          <FormCorreoElectronico
            ref={ref}
            nextStep={nextStep}
            prevStep={prevStep}
            showToast={showToast}
            {...props}
          />
        </Box>
      </Slide>
    </div>
  );
});

export default CorreoElectronico;
